/** * @name: frameHeader * @author: weiyong * @date: 2022-10-02 21:00 * @description：frameHeader *
@update: 2022-10-02 21:00 */
<template>
  <div class="top-header" :class="[prefixCls, 'top-header-' + getHeaderTheme]">
    <div class="top-header-left">
      <div class="back-icon-item" v-if="back" @click="backToHome">
        <LeftOutlined />
      </div>

      <Dropdown>
        <div class="ant-dropdown-link app-operation-menu flex-div">
          <div style="margin-right: 4px; font-size: 14px">
            {{ subAppTitle }}
          </div>
          <div>
            <CaretDownOutlined />
          </div>
        </div>
        <template #overlay>
          <Menu @click="clickMenuItem">
            <!--            <menu-item key="seeExpandInfo" v-if="showType==='template'">-->
            <!--              <a href="javascript:;">-->
            <!--                <span class="remix-icon ri-article-line" style="display: inline-block;padding-right: 8px;"></span>-->
            <!--                {{t('dev.查看应用说明')}}-->
            <!--              </a>-->
            <!--            </menu-item>-->

            <menu-item key="shareApp">
              <a href="javascript:;"
                ><span
                  class="remix-icon ri-links-fill"
                  style="display: inline-block; padding-right: 8px"
                ></span
                >{{ t('dev.分享应用') }}</a
              >
            </menu-item>

            <!--            <menu-item key="saveApp" v-if="showType==='template'">-->
            <!--              <a href="javascript:;" >-->
            <!--                <span class="remix-icon ri-hand-heart-line" style="display: inline-block;padding-right: 8px;"></span>-->
            <!--                收藏应用-->
            <!--              </a>-->
            <!--            </menu-item>-->
          </Menu>
        </template>
      </Dropdown>

      <div class="line"></div>

      <AppSpaceSelItem
        :showType="showType"
        :appId="appId"
        spaceType="app"
        class="appSpaceSelItem"
      ></AppSpaceSelItem>

      <div class="line"></div>

      <div class="" v-if="!showAppFlag">
        <!--        <LayoutBreadcrumb v-if="getShowContent && getShowBread" :theme="getHeaderTheme"/>-->
      </div>
    </div>
    <div class="top-header-right" style="padding-right: 22px">
      <AppLocalePicker
        v-if="getShowLocalePicker"
        :reload="true"
        :showText="false"
        :class="`${prefixCls}-action__item`"
      />

      <Notify v-if="getShowNotice" :class="`${prefixCls}-action__item notify-item`" />
      <!--用户菜单下拉-->
      <UserDropDown :theme="getHeaderTheme" />

      <UpdateLogIcon :class="`${prefixCls}-action__item`" />

      <div class="line" v-if="!showAppFlag && getShowContent && getShowBread"></div>

      <div @click="openDocSystem" class="helpIcon">
        <question-circle-outlined />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  export default defineComponent({
    components: {},
    name: 'frameHeader',
  });
</script>

<script lang="ts" setup>
  import { LayoutBreadcrumb } from '@/layouts/default/header/components';
  import AppSpaceSelItem from '@/layouts/default/header/components/AppSpaceSelItem.vue';
  import { UserDropDown, Notify, UpdateLogIcon } from '@/layouts/default/header/components';
  import { Dropdown, Menu, MenuItem } from 'ant-design-vue';
  import { useDesign } from '@/hooks/web/useDesign';
  import { message } from 'ant-design-vue';
  import { LeftOutlined, CaretDownOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue';
  import { useI18n } from 'vue-i18n';
  import { AppLocalePicker } from '@/components/Application';

  import { useSubAppInfos } from '@/hooks/layouts/useSubAppInfos';
  //子应用标题
  const { subAppTitle } = useSubAppInfos();
  const { prefixCls } = useDesign('frameHeader');
  const { t } = useI18n();
  const { getShowContent, getShowBread, getHeaderTheme, getShowNotice } = useHeaderSetting();

  import { useRouter } from 'vue-router';
  import { useHeaderSetting } from '@/hooks/setting/useHeaderSetting';
  import { useLocale } from '@/i18n/useLocale';
  import { toRefs } from 'vue';
  import useClipboard from 'vue-clipboard3';
  import SysConfigUtils from '@/utils/sysConfigUtils';
  import {StorageUtils} from 'xmgoing-utils';
  import GoingUtils from '@/utils/goingUtils';
  import { useUserStore } from '@/store/modules/user';

  const { toClipboard } = useClipboard();
  const router = useRouter();
  //返回首页
  const backToHome = function () {
    router.push({ path: '/dashboard' });
  };
  const userStore = useUserStore();
  const { getShowLocalePicker } = useLocale();

  const props = defineProps({
    showType: {
      type: String,
      default: '',
    },
    appId: {
      type: String,
      default: '',
    },
    back: {
      type: Boolean,
      default: true,
    },
  });
  const { back, appId } = toRefs(props);

  const showAppFlag = ref(userStore.showAppFlag);

  const openDocSystem = () => {
    window.open(SysConfigUtils.docCenterUrl + 'appHelp');
  };
  /**
   * 应用分享
   */
  const copy = async () => {
    const showApp = StorageUtils.getSessionItem('showApp');

    //如果是应用预览
    if (showApp + '' === 'true') {
      try {
        const url = `${
          SysConfigUtils.templatePreviewUrl
        }/appShow?templateId=${sessionStorage.getItem('templateId')}
      &appName=${StorageUtils.getSessionItem('appName')}
      &appId=${sessionStorage.getItem('appId')}&sessionId=${sessionStorage.getItem('sessionId')}`;
        await toClipboard(url);
        message.success(t('dev.地址复制成功！'));
      } catch (e) {
        console.error(e);
      }
    } else {
      try {
        const url = `${SysConfigUtils.templatePreviewUrl}/appShowByApp?appId=${unref(
          appId,
        )}&sessionId=${sessionStorage.getItem('sessionId')}`;
        await toClipboard(url);
        message.success(t('dev.地址复制成功！'));
      } catch (e) {
        console.error(e);
      }
    }
  };

  const clickMenuItem = ({ key }) => {
    if (key === 'shareApp') {
      copy();
    } else if (key === 'seeExpandInfo') {
    }
  };
</script>

<style type="text/css" lang="less">
  @prefix-cls: ~'@{namespace}-frameHeader';
  @sub-header-app: 50px;

  .@{prefix-cls} {
    .helpIcon{
      margin-left: 12px;position: relative;top:1px;cursor: pointer;
    }

    .@{namespace}-frameHeader-action__item {
      display: flex !important;
      height:  @sub-header-app;
      padding: 0 14px;
      color:#FFF;
      font-size: 1.2em;
      cursor: pointer;
      align-items: center;
      &:hover {
        background-color: #006fff;
        color:#FFF;
      }
      svg{
        color:#FFF !important;
      }
    }
    .appSpaceSelItem{
      &.@{namespace}-SpaceSelItem.space-sel-item{
        height:  @sub-header-app;
        &:hover{
          background-color: @header-light-bg-hover-color;
          color: #333 !important;
        }
      }
    }

    .@{namespace}-header-user-dropdown{
      height: @sub-header-app;
      &:hover{
        .@{namespace}-header-user-dropdown__name{
          color:#666;
        }
      }
    }

    .app-operation-menu{
      display: flex;
      align-items: center;
      cursor:pointer;
      margin-right: 12px;
    }
    &.top-header {
      &.top-header-dark{
        color: #fff;
        .@{namespace}-frameHeader-action__item {
          &:hover {
            color:#FFF;
            background-color: @header-dark-bg-hover-color;
          }
          svg{
            color:#FFF !important;
          }
        }

        .@{namespace}-header-user-dropdown__name{
          color:#FFF;
          &:hover{
            color:#FFF;
          }
        }
      }
      &.top-header-light{
        border-bottom: 1px solid #eee;
        .@{namespace}-frameHeader-action__item {
          &:hover {
            color:#666;
            background-color: @header-light-bg-hover-color;
          }
          svg{
            color:#666 !important;
          }
        }

        .@{namespace}-header-user-dropdown__name{
          color:#666;
          &:hover{
            color:#333;
          }
        }
      }
      height: @sub-header-app;
      display: flex;
      justify-content: space-between;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 2px;
      box-sizing: border-box;
      align-items: center;
      background-color: var(--header-bg-color, #FFF);
      //background: linear-gradient(80deg, #006fff 5%, #1aa0ff 93%) !important;

      .top-header-left {
        display: flex;
        padding: 0 8px;
        align-items: center;
      }
      .top-header-right{
        display: flex;
        align-items: center;
      }

      .line {
        width: 1px;
        height: 18px;
        position: relative;
        opacity: .2;
        background: #fff;
      }

      .back-icon-item {
        padding: 0 12px;
        display: flex;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
</style>
